import moment from 'moment';
import React from 'react';

interface IProps {
  label: string;
  value?: Date | string | null;
}

export const DateLabel = ({ label, value }: IProps) => {
  return (
    <div>
      <p>{label}</p>
      <strong>{value ? moment(value, 'DD/MM/YYYY').utc().format('DD/MM/YYYY') : '-'}</strong>
    </div>
  );
};
